import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4.75H22",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.25 0.75H8.75C8.35218 0.75 7.97064 0.908035 7.68934 1.18934C7.40804 1.47064 7.25 1.85218 7.25 2.25V4.75H14.75V2.25C14.75 1.85218 14.592 1.47064 14.3107 1.18934C14.0294 0.908035 13.6478 0.75 13.25 0.75Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75 17.5V10",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.25 17.5V10",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.86 21.37C17.8322 21.7458 17.663 22.0971 17.3865 22.3532C17.1101 22.6092 16.7468 22.751 16.37 22.75H5.63C5.25317 22.751 4.88994 22.6092 4.61347 22.3532C4.337 22.0971 4.16782 21.7458 4.14 21.37L2.75 4.75H19.25L17.86 21.37Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		})
	]
});
export { SvgIconTrash as ReactComponent };
